import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NavLink } from '@myphx-engineering/phx-design-system';

import { getAbsoluteRoute } from '../../../util';

export const PrescriptionHistoryLink = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <NavLink
            label={t('cabinet.historyNav')}
            onClick={() => navigate(getAbsoluteRoute('cabinet.history'))}
            variant="subtle"
        />
    );
};
